import { jsx as e, jsxs as u } from "react/jsx-runtime";
import f, { Children as _ } from "react";
import h from "./index40.js";
import { c as l } from "./index41.js";
const I = ({
  value: a = null,
  selectRef: c,
  ...n
}) => {
  const i = ({
    children: s,
    ...t
  }) => {
    const { ValueContainer: m, Placeholder: r } = l, p = _.toArray(s).filter((o) => !(f.isValidElement(o) && o.type === r));
    return /* @__PURE__ */ u(m, { ...t, children: [
      p,
      /* @__PURE__ */ e(
        r,
        {
          ...t,
          isFocused: !1,
          innerProps: t.innerProps ?? {},
          children: /* @__PURE__ */ e("span", { className: "selects__placeholder-text", children: t.selectProps.placeholder })
        }
      )
    ] });
  }, d = (s) => /* @__PURE__ */ e(l.DropdownIndicator, { ...s, children: /* @__PURE__ */ e("span", { className: "selects__dropdown-indicator-icon" }) });
  return /* @__PURE__ */ e("div", { className: "textbox-ui select-ui", children: /* @__PURE__ */ e(
    h,
    {
      ...n,
      value: a,
      noOptionsMessage: n.noOptionsMessage || (() => "Sem resultados"),
      className: "block-selects",
      classNamePrefix: "selects",
      unstyled: !0,
      components: {
        IndicatorSeparator: () => null,
        DropdownIndicator: d,
        LoadingIndicator: x,
        ValueContainer: i
      },
      ref: c
    }
  ) });
}, x = () => /* @__PURE__ */ e("span", { className: "selects__indicator selects__loading-indicator" });
export {
  I as Select
};
